import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Typography, Button } from '@mui/material';
import { Icon } from '@livable/saas-react-components';
import { observer } from 'mobx-react-lite';
import usePortfolioAccordionItemStyles from './styles';
import { useTranslation } from 'react-i18next';
export const PortfolioAccordionItem = observer(_ref => {
  var _portfolioDataExt$pro;
  let portfolioDataExt = _ref.portfolioDataExt,
    handleGrantAccess = _ref.handleGrantAccess,
    getIsAccessGranted = _ref.getIsAccessGranted;
  const classes = usePortfolioAccordionItemStyles();
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const grantAllPortfolioAccess = (event, portfolioData) => {
    event.stopPropagation();
    handleGrantAccess(undefined, portfolioData.id);
  };
  const PropertyListItem = _ref2 => {
    let propertyData = _ref2.propertyData,
      isListEmpty = _ref2.isListEmpty;
    return /*#__PURE__*/React.createElement("div", {
      key: propertyData === null || propertyData === void 0 ? void 0 : propertyData.propertyId
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(classes.propertyListItem, " ").concat(getIsAccessGranted(propertyData === null || propertyData === void 0 ? void 0 : propertyData.propertyId, portfolioDataExt.id) ? classes.activeItem : '')
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(classes.propertyListItemTitle)
    }, !isListEmpty && /*#__PURE__*/React.createElement(Icon, {
      type: "building"
    }), /*#__PURE__*/React.createElement(Typography, {
      variant: "body1"
    }, propertyData === null || propertyData === void 0 ? void 0 : propertyData.propertyAddress, " "))));
  };
  return /*#__PURE__*/React.createElement(Accordion, {
    key: portfolioDataExt.id,
    className: classes.accordion,
    expanded: isOpen
  }, /*#__PURE__*/React.createElement(AccordionSummary, {
    "aria-controls": "content",
    className: "".concat(getIsAccessGranted(undefined, portfolioDataExt === null || portfolioDataExt === void 0 ? void 0 : portfolioDataExt.id) ? classes.activeItem : ''),
    expandIcon: /*#__PURE__*/React.createElement(Icon, {
      state: 'grey',
      fontSize: "large",
      type: "arrow-line-right"
    }),
    id: "allocation-header",
    onClick: () => setIsOpen(prevValue => !prevValue)
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.accordionContent, " ").concat(getIsAccessGranted(undefined, portfolioDataExt === null || portfolioDataExt === void 0 ? void 0 : portfolioDataExt.id) ? classes.activeItem : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.title
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.titleText
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "folder-house"
  }), /*#__PURE__*/React.createElement(Typography, {
    color: "light",
    variant: "h5"
  }, portfolioDataExt.name)), getIsAccessGranted(undefined, portfolioDataExt === null || portfolioDataExt === void 0 ? void 0 : portfolioDataExt.id) ? /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, /*#__PURE__*/React.createElement(Icon, {
    fontSize: "small",
    type: "success",
    state: "success"
  }), t('team_page.access_granted')), /*#__PURE__*/React.createElement(Button, {
    variant: "actionIcon",
    onClick: event => grantAllPortfolioAccess(event, portfolioDataExt),
    'custom-attribute': '276-portfolio-accordion-item'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "error"
  }))) : /*#__PURE__*/React.createElement(Button, {
    variant: "actionIcon",
    onClick: event => grantAllPortfolioAccess(event, portfolioDataExt),
    'custom-attribute': '277-portfolio-accordion-item'
  }, /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('team_page.grant_access')))))), /*#__PURE__*/React.createElement(AccordionDetails, null, /*#__PURE__*/React.createElement("div", {
    className: classes.accordionContent
  }, !!(portfolioDataExt !== null && portfolioDataExt !== void 0 && (_portfolioDataExt$pro = portfolioDataExt.properties) !== null && _portfolioDataExt$pro !== void 0 && _portfolioDataExt$pro.length) ? portfolioDataExt.properties.map(property => /*#__PURE__*/React.createElement(PropertyListItem, {
    key: property.propertyId,
    propertyData: property
  })) : /*#__PURE__*/React.createElement(PropertyListItem, {
    key: "key-empty-portfolio".concat(portfolioDataExt.id),
    propertyData: {
      propertyAddress: t('team_page.no_properties')
    },
    isListEmpty: true
  }))));
});